import { Component } from '@angular/core';

@Component({
  selector: 'nv-session-storage-agreement-withdrawal',
  templateUrl: './storage-agreement-withdrawal.component.html',
})
export class StorageAgreementWithdrawalComponent {
  backToStartLink = '/';
}
